/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { store } from "@/store";
import { BotStore } from "@/store/constants";
import { IBlock, IFlow } from "@chatcaptain/types/chatbot";
import {
  getFirestore,
  doc,
  updateDoc,
  serverTimestamp,
  getDoc,
  deleteField,
} from "firebase/firestore";
import { fetchCloudRun } from "../../Helper";

export interface ICreateFlowResponse {
  flow: IFlow;
  entry: IBlock;
  outlet: IBlock;
}

export const createSubFlow = async (
  name: string,
  parentFlowId: string,
  parentFlowBlockId: string
): Promise<ICreateFlowResponse> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  const response = await fetchCloudRun(
    "https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/flows",
    "POST",
    {},
    {
      name,
      parent_id: parentFlowId,
      parent_block_id: parentFlowBlockId,
    }
  );
  return response;
};

export const updateFlow = async (id: string, name: string) => {
  await updateDoc(
    doc(
      getFirestore(),
      "dialogs/" + store.getters[BotStore.Getters.GET_ID] + "/flows/" + id
    ),
    {
      updated: serverTimestamp(),
      name,
    }
  );
};

export const updateOutletName = async (
  flowId: string,
  outletId: string,
  name: string
) => {
  const flow = store.getters[BotStore.Getters.GET_FLOW](flowId) as
    | IFlow
    | undefined;
  if (flow && flow.parent && flow.parent.flow_id && flow.parent.block_id) {
    await updateDoc(
      doc(
        getFirestore(),
        "dialogs/" +
          store.getters[BotStore.Getters.GET_ID] +
          "/flows/" +
          flow.parent.flow_id +
          "/blocks/" +
          flow.parent.block_id
      ),
      {
        updated: serverTimestamp(),
        ["outlets." + outletId + ".name"]: name,
      }
    );
  }
};

export const deleteOutlet = async (flowId: string, outletId: string) => {
  const flow = store.getters[BotStore.Getters.GET_FLOW](flowId) as
    | IFlow
    | undefined;
  if (flow && flow.parent && flow.parent.flow_id && flow.parent.block_id) {
    await updateDoc(
      doc(
        getFirestore(),
        "dialogs/" +
          store.getters[BotStore.Getters.GET_ID] +
          "/flows/" +
          flow.parent.flow_id +
          "/blocks/" +
          flow.parent.block_id
      ),
      {
        updated: serverTimestamp(),
        ["outlets." + outletId]: deleteField(),
      }
    );
  }
};

export const deleteSubFlow = async (flowId: string): Promise<void> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  await fetchCloudRun(
    "https://app.chatcaptain.com/api/bot/chatbots/" +
      chatbotId +
      "/flows/" +
      flowId,
    "DELETE"
  );
};
